// src/data/masterBlasterData.js

import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

export const holsterData = {
  brands: [
    { id: "1911", name: "1911" },
    { id: "kimber", name: "Kimber" },
    { id: "FN", name: "FN" },
    { id: "glock", name: "Glock" },
    { id: "mossberg", name: "Mossberg" },
    { id: "ruger", name: "Ruger" },
    { id: "sig", name: "Sig Sauer" },
    { id: "sw", name: "Smith & Wesson" },
    { id: "springfield", name: "Springfield Armory" },
    { id: "walther", name: "Walther" },
  ],

  // --- SUBCOMPACT MODELS ONLY ---
  guns: [
    // 1911
    { id: "1911", brand_id: "1911", name: "1911 3inch 45 ACP (DOES NOT FIT SIG 1911)" },
     // FN
    { id: "FN", brand_id: "FN", name: "FN 503" },
    // GLOCK
    { id: "glock42", brand_id: "glock", name: "Glock 42" },
    { id: "glock43", brand_id: "glock", name: "Glock 43" },
    { id: "glock43x", brand_id: "glock", name: "Glock 43X (includes MOS)" },
    { id: "glock48", brand_id: "glock", name: "Glock 48 (includes MOS)" },

     // Kimber
    { id: "kimber", brand_id: "kimber", name: "EVO SP" },

     // Mossberg
    { id: "mossberg", brand_id: "mossberg", name: "MC 1" },

    // SIG
    { id: "sig_p365", brand_id: "sig", name: "Sig P365 / SAS" },
    { id: "sig_p365xl", brand_id: "sig", name: "Sig P365 XL" },
    { id: "sig_p365x", brand_id: "sig", name: "Sig P365 (X)" },
    { id: "sig_p238", brand_id: "sig", name: "Sig P238" },
    { id: "sig_p938", brand_id: "sig", name: "Sig P938" },

    // S&W
    { id: "sw_shield_plus", brand_id: "sw", name: "Shield Plus" },
    { id: "sw_shield_ez_9", brand_id: "sw", name: "Shield 9mm EZ" },
    { id: "sw_shield_ez_380", brand_id: "sw", name: "Shield 380 EZ" },
    { id: "sw_mp_shield45", brand_id: "sw", name: "M&P Shield 45 (fits 2.0)" },
    { id: "sw_mp_shield940", brand_id: "sw", name: "M&P Shield 9/40 (fits 2.0)" },
    { id: "sw_bodyguard", brand_id: "sw", name: "Bodyguard 2.0 (Does Not Fit Carry Comp)" },
    { id: "sw_bodyguard380", brand_id: "sw", name: "Bodyguard 380 NO Laser" },
    { id: "sw_bodyguard380wlaser", brand_id: "sw", name: "Bodyguard 380 W/ CT Red Laser" },

    // SPRINGFIELD
    { id: "SpringfieldXDs3_3_45", brand_id: "springfield", name: "Springfield XDs 3.3 45 ACP" },
    { id: "SpringfieldXDs3_3_9_40", brand_id: "springfield", name: "Springfield XDs 3.3 9/40" },
    { id: "SpringfieldXDs4_0_45", brand_id: "springfield", name: "Springfield XDs 4.0 45 ACP" },
    { id: "SpringfieldXDs4_0_9_40", brand_id: "springfield", name: "Springfield XDs 4.0 9/40" },

    // RUGER
    { id: "ruger_lcp_380", brand_id: "ruger", name: "Ruger LCP 380" },
    { id: "ruger_lcp2", brand_id: "ruger", name: "Ruger LCP II" },
    { id: "ruger_lc9", brand_id: "ruger", name: "Ruger LC9" },

    // Walther
    { id: "walther_ccp", brand_id: "walther", name: "Walther CCP" },
    { id: "walther_ppsm1", brand_id: "walther", name: "Walther PPS M1" },
    { id: "walther_ppsm2", brand_id: "walther", name: "Walther PPS M2" },
  ],

  hands: [ { id: "right", name: "Right Handed" }, { id: "left", name: "Left Handed" } ],

  // --- COLORS (Mapped for $20 Camo Markup) ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 20),

  // --- MOUNTS (Now pointing to the dedicated masterblaster folder) ---
  mounts: [
    { 
      id: "clip_15", 
      name: "1.5\" Injection Molded Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/masterblaster/clip_15_front.png", 
      img_layer_mount_back: "/images/mounts/masterblaster/clip_15_back.png",
      description: "Standard injection molded clip. Durable, reliable, reverse tab."
    },
    { 
      id: "clip_175", 
      name: "1.75\" Injection Molded Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/masterblaster/clip_175_front.png", 
      img_layer_mount_back: "/images/mounts/masterblaster/clip_175_back.png",
      description: "Standard injection molded clip for wider belts."
    },
    { 
      id: "dcc_ANRlogo", 
      name: "1.5\" DCC ANR Logo", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/masterblaster/dcc_anr_front.png", 
      img_layer_mount_back: "/images/mounts/masterblaster/dcc_anr_back.png",
      description: "Heat treated steel alloy. High clamping force."
    },
    { 
      id: "dcc_TOPOlogo", 
      name: "1.5\" DCC TOPO", 
      price: 8.25, 
      img_layer_mount: "/images/mounts/masterblaster/dcc_topo_front.png", 
      img_layer_mount_back: "/images/mounts/masterblaster/dcc_topo_back.png",
      description: "Heat treated steel alloy with TOPO design."
    },
    { 
      id: "dcc_tigerstripe", 
      name: "1.5\" DCC Tiger Stripe", 
      price: 8.25, 
      img_layer_mount: "/images/mounts/masterblaster/dcctigerstripe_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/masterblaster/dcctigerstripe_back.png",
      description: "Heat treated steel alloy with Tiger Stripe design."
    },
    { 
      id: "dcc_FDElogo", 
      name: "1.5\" DCC FDE", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/masterblaster/dcc_fde_front.png", 
      img_layer_mount_back: "/images/mounts/masterblaster/dcc_fde_back.png", // <--- Fixed the missing /mounts/ here!
      description: "Heat treated steel alloy in FDE."
    },
    { 
      id: "dcc_nologo", 
      name: "1.5\" DCC No Logo", 
      price: 6.25, 
      img_layer_mount: "/images/mounts/masterblaster/dcc_nologo_front.png", 
      img_layer_mount_back: "/images/mounts/masterblaster/dcc_nologo_back.png",
      description: "Heat treated steel alloy. High clamping force. Clean, no logo finish."
    },
    { 
      id: "neomag", 
      name: "NeoMag Alias TPost", 
      price: 15.99, 
      img_layer_mount: "/images/mounts/masterblaster/neomag_front.png",
      img_layer_mount_back: "/images/mounts/masterblaster/neomag_back.png",
      description: "Premium clip-less system. Requires NeoMag Alias belt receiver."
    },
    {
      id: "neomag_receiver", 
      name: "Neomag Alias TPost and Neomag Alias Belt Receiver",
      price: 49.99, 
      img_layer_mount: "/images/mounts/masterblaster/neomag_recv_front.png",
      img_layer_mount_back: "/images/mounts/masterblaster/neomag_recv_back.png",
      description: "Includes Neomag T Post + Receiver Addon for belt."
    },
],
  // --- CLAWS (Now pointing to the dedicated masterblaster folder) ---
  claws: [
    { id: "no",  name: "No Thanks", price: 0 },
    { 
      id: "black", 
      name: "Add Black Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/masterblaster/claw_black_front.png", 
      img_layer_claw_back:  "/images/claws/masterblaster/claw_black_back.png" 
    },
    { 
      id: "od_green", 
      name: "Add OD Green Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/masterblaster/claw_od_green_front.png", 
      img_layer_claw_back:  "/images/claws/masterblaster/claw_od_green_back.png" 
    },
    { 
      id: "coyote", 
      name: "Add Coyote Concealment Claw", 
      price: 12.00, 
      img_layer_claw_front: "/images/claws/masterblaster/claw_coyote_front.png", 
      img_layer_claw_back:  "/images/claws/masterblaster/claw_coyote_back.png" 
    },
  ],

  // --- BREAKTHROUGH ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};